import "./App.css";
import FeeCalculator from "./components/screens/agent/FeeCalculator";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import AdminDashboard from "./components/screens/admin/AdminDashboard";
import Login from "./components/auth/Login";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import ManageAgentData from "./components/screens/admin/AddAgent";
import ForgotPassword from "./components/auth/ForgotPassword";
import SetPassword from "./components/auth/setPassword";
import AdminFeesUI from "./components/screens/admin/ManageAgentData";
import MainLayout from "./layout/MainLayout";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route
            path="/calculator/:userId"
            element={
              <ProtectedRoute>
                <FeeCalculator />
              </ProtectedRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/calculator/:userId" element={<FeeCalculator />} />
          <Route path="/set-password/:userId" element={<SetPassword />} />

          {/* Admin layout with protected routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {/* This is the default route when you visit /admin */}
            <Route index element={<ManageAgentData />} />
            {/* <Route index element={<AdminDashboard />} /> */}
            <Route path="manage-agent" element={<ManageAgentData />} />
            <Route path="manage-data" element={<AdminFeesUI />} />
            <Route path="agent-data/:agentId" element={<AdminFeesUI />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
